import React from 'react';
import HeroSection from '../components/HeroSection';
import UrgentPreachingSection from '../components/UrgentPreachingSection';
import PowerOfKnowledgeSection from '../components/PowerOfKnowledgeSection';
import SevaOfferingsSection from '../components/SevaOfferingsSection';
import EternalBenefitSection from '../components/EternalBenefitSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="homepage">
      <HeroSection />
      <UrgentPreachingSection />
      <PowerOfKnowledgeSection />
      <SevaOfferingsSection />
      <EternalBenefitSection />
      <Footer />
    </div>
  );
};

export default HomePage;